import React, { useCallback, useEffect, useState } from "react";
import {
  ArrowUpIcon,
  CashIcon,
  ChevronDownIcon,
  ClockIcon,
  LocationMarkerIcon,
  SearchCircleIcon,
  UsersIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import {
  faCar,
  faSearch,
  faUserTie,
  faArrowRight,
  faMapMarker,
  faPencilAlt,
  faArrowLeft,
  faHourglassEnd,
  faClock,
  faTimes,
  faCalendar,
} from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BookingMap from "./BookingMap";
import BookingDetailsItem from "./BookingDetailsItem";
import {
  faArrowsLeftRight,
  faCalendarWeek,
  faClose,
  faCross,
  faList,
  faSignsPost,
} from "@fortawesome/free-solid-svg-icons";

import InputField from "../landingPage/InputField";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  getVehicles,
  getVehiclesErr,
} from "../../redux/app/vehicle/vehicle-slice";
import momenttz from "moment-timezone";
import {
  changeDestinationInput,
  changeSourceInput,
  clearDestinationInput,
  clearSourceInput,
  setDestinationInput,
  setSourceInput,
} from "../../redux/app/map/map-slice";
import { useNavigate } from "react-router-dom";
import {
  clearCurrency,
  clearPassenger,
  selectPassenger,
  setBookingDetails,
  setConvertedPrice,
  setCurrency,
  setDropDownOpen,
  setSearchResultScreen,
  setisSearchingprice,
} from "../../redux/app/booking/booking-slice";

import AutoCompletePlaceItem from "./AutoCompletePlaceItem";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import DatePicker from "react-date-picker";
import { TimePicker } from "react-ios-time-picker";
import axios from "axios";
import { Icon } from "@mui/material";
import { toast } from "react-toastify";

let vehicleCurrency = {};
function SearchResultHeading({
  flatrate,
  b2b,
  searchCompleted,
  searchCurrent,
  chVehicleCompleted,
  chVehicleCurrent,
  passengerCompleted,
  passengerCurrent,
  bkSummaryCompleted,
  bkSummaryCurrent,
  handleDrawer,
  handleDrawerOpen,
  openDrawer,
  showBookingDetail,
}) {
  const { booking, distance } = useSelector((state) => state.booking);
  const [editBooking, seteditBooking] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, user } = useSelector((state) => state.auth);

  const [formSwitchOneWay, setformSwitchOneWay] = useState(true);
  const {
    sourceInputFromApi,
    sourceInput,
    destinationInput,
    destinationInputFromApi,
    placesbygoogle,
    placesbygoogleForDestination,
  } = useSelector((state) => state.map);
  const {
    selectedPassenger,
    timeDetails,
    selectdCurrency,
    sourceLatLan,
    destinationLatLan,
    distanceInKm,
    bookingDuration,
    isSearhingCar,
    sourceWithRegion,
    destinationWithRegion,
    checkSourceRegion,
    checkDestinationRegion,
  } = useSelector((state) => state.booking);
  const { vehicles, err, durationflat, distanceflat } = useSelector(
    (state) => state.vehicle
  );

  const [dateChange, setDateChange] = useState();
  const [timeChange, setTimeChange] = useState("10:00");
  const [tzUpdate, setTzUpdate] = useState();
  const [hourlyTime, sethourlyTime] = useState();
  // let time = momenttz
  //   .tz(
  let time = dateChange + " " + timeChange; // timeDetails.timezone_location

  // )
  // .format("YYYY-MM-DD HH:mm:ss");

  useEffect(() => {
    let t = moment(time).format("YYYY-MM-DD HH:mm ");
    setTzUpdate(t);
  }, [timeDetails.timezone, time]);

  useEffect(() => {
    if (vehicles === undefined) {
      if (checkDestinationRegion && checkSourceRegion && dateChange) {
        dispatch({
          type: "SEARCH_INITIATE",
        });
      }
    }
  }, [
    vehicles,
    checkDestinationRegion,
    checkSourceRegion,
    dateChange,
    dispatch,
  ]);

  // useEffect(() => {
  //   if (vehicles) {
  //     vehicles?.forEach(async (v) => {
  //       let payload = {
  //         vehicleType: v?.vehicleType,
  //         from: "USD",
  //         to: selectdCurrency,
  //         amount: v?.price,
  //         usdprice: v?.price,
  //       };

  //       let res = await axios.get(
  //         `${process.env.REACT_APP_BASE_URL}/bookings/currencyLayer?from=${payload.from}&to=${payload.to}&amount=${payload.amount}`
  //       );

  //       vehicleCurrency = {
  //         ...vehicleCurrency,
  //         [v?.vehicleType]: res?.data?.result,
  //       };
  //       dispatch(
  //         setConvertedPrice({
  //           convertedPrice: vehicleCurrency,
  //         })
  //       );

  //
  //         res.data.result,
  //         `res.data ${v?.vehicleType} usd -> ${v?.price}`
  //       );
  //       payload = {};
  //     });
  //     dispatch(
  //       setSearchResultScreen({
  //         searchResultScreen: true,
  //       })
  //     );
  //   }
  // }, [vehicles, selectdCurrency]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (sourceInputFromApi && hourlyTime && dateChange) {
        dispatch({
          type: "GET_VEHICLES_WITH_PRICE_HOURLY",
          payload: {
            sourceplaceid: sourceInputFromApi.place_id,
            hour: hourlyTime?.hour,
            distance: hourlyTime?.distance,
            date: dateChange,
          },
        });
      }
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [sourceInputFromApi, hourlyTime, dateChange, dispatch]);

  const [openDatePicker, setopenDatePicker] = useState(false);
  const [openPassengerSelect, setopenPassengerSelect] = useState(false);
  const [openCurrency, setOpenCurrency] = useState(false);

  // const wrapperRef = useRef("");
  // outsideClick(wrapperRef, () => {
  //   setOpenCurrency(false);
  // });

  let passenger = [];
  for (let i = 0; i < 6; i++) {
    passenger.push(i + 1);
  }

  let Currency = [
    "USD",
    "INR",
    "EUR",
    "GBP",
    "AUD",
    "CAD",
    "SGD",
    "JPY",
    "AED",
    "CNY",
    "KWD",
    "NZD",
    "QAR",
    "SAR",
    "SGD",
    "OMR",
  ];

  const duration = [
    {
      hour: 1,
      distance: 20,
    },
    {
      hour: 2,
      distance: 40,
    },
    {
      hour: 3,
      distance: 60,
    },
    {
      hour: 4,
      distance: 80,
    },
    {
      hour: 5,
      distance: 100,
    },
    {
      hour: 6,
      distance: 120,
    },
    {
      hour: 7,
      distance: 140,
    },
    {
      hour: 8,
      distance: 160,
    },
    {
      hour: 9,
      distance: 180,
    },
    {
      hour: 10,
      distance: 200,
    },
    {
      hour: 11,
      distance: 220,
    },
    {
      hour: 12,
      distance: 240,
    },
    {
      hour: 13,
      distance: 260,
    },
    {
      hour: 14,
      distance: 280,
    },
    {
      hour: 15,
      distance: 300,
    },
    {
      hour: 16,
      distance: 320,
    },
    {
      hour: 17,
      distance: 340,
    },
    {
      hour: 18,
      distance: 360,
    },
    {
      hour: 19,
      distance: 380,
    },
    {
      hour: 20,
      distance: 400,
    },
    {
      hour: 21,
      distance: 420,
    },
    {
      hour: 22,
      distance: 440,
    },
    {
      hour: 23,
      distance: 460,
    },
    {
      hour: 24,
      distance: 480,
    },
  ];

  const [openHour, setOpenHour] = useState(false);

  let travelTimeInSeconds = new Date(tzUpdate).getTime() / 1000;
  let currentTimeInSeconds = new Date(timeDetails.datetime).getTime() / 1000;
  let timeDiffInSeconds = Math.abs(travelTimeInSeconds - currentTimeInSeconds);

  // handlers
  const handleTimeChange = useCallback(
    (timeValue) => {
      setTimeValue(timeValue);
      setTimeChange(timeValue);

      dispatch({
        type: "GET_LAT_LAN_OF_SOURCE",
        payload: sourceInputFromApi?.place_id,
      });
    },
    [dispatch, sourceInputFromApi]
  );

  // find locations when key stoke is there for source input
  const handleSourceChange = useCallback(
    (e) => {
      dispatch(
        getVehicles({
          vehicle: undefined,
        })
      );
      dispatch(
        getVehiclesErr({
          vehicle: undefined,
        })
      );
      dispatch(
        changeSourceInput({
          sourceInput: e.target.value,
        })
      );
      dispatch({ type: "GET_PLACES_FROM_GOOGLE", payload: e.target.value });
    },
    [dispatch]
  );

  // const vechicleCurrencyUpdate = (selectdCurrency) => {
  //   vehicles?.forEach(async (v) => {
  //     let payload = {
  //       vehicleType: v?.vehicleType,
  //       from: "USD",
  //       to: selectdCurrency,
  //       amount: v?.price,
  //       usdprice: v?.price,
  //     };

  //     let res = await axios.get(
  //       `${process.env.REACT_APP_BASE_URL}/bookings/currencyLayer?from=${payload.from}&to=${payload.to}&amount=${payload.amount}`
  //     );

  //     vehicleCurrency = {
  //       ...vehicleCurrency,
  //       [v?.vehicleType]: res.data.result,
  //     };
  //     dispatch(
  //       setConvertedPrice({
  //         convertedPrice: vehicleCurrency,
  //       })
  //     );

  //
  //       res.data.result,
  //       `res.data ${v?.vehicleType} usd -> ${v?.price}`
  //     );
  //     payload = {};
  //   });
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    // vehicles?.forEach(async (v) => {
    //   let payload = {
    //     vehicleType: v?.vehicleType,
    //     from: "USD",
    //     to: selectdCurrency,
    //     amount: v?.price,
    //     usdprice: v?.price,
    //   };

    //   let res = await axios.get(
    //     `${process.env.REACT_APP_BASE_URL}/bookings/currencyLayer?from=${payload.from}&to=${payload.to}&amount=${payload.amount}`
    //   );

    //   vehicleCurrency = {
    //     ...vehicleCurrency,
    //     [v?.vehicleType]: res.data.result,
    //   };
    //   dispatch(
    //     setConvertedPrice({
    //       convertedPrice: vehicleCurrency,
    //     })
    //   );

    //
    //     res.data.result,
    //     `res.data ${v?.vehicleType} usd -> ${v?.price}`
    //   );
    //   payload = {};
    // });

    if (
      sourceInput === undefined ||
      destinationInput === undefined ||
      tzUpdate === undefined ||
      dateChange === undefined
    ) {
      toast.warning("Please fill all the fields", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
      });
    } else {
      const payload = {
        source: {
          placename: sourceInputFromApi?.description,
          placeid: sourceInputFromApi?.place_id,
          lat: sourceLatLan.split(",")[0],
          lng: sourceLatLan.split(",")[1],
        },
        destination: {
          placename: destinationInputFromApi?.description,
          placeid: destinationInputFromApi?.place_id,
          lat: destinationLatLan.split(",")[0],
          lng: destinationLatLan.split(",")[1],
        },
        travelDate: dateChange,
        travelTime: tzUpdate,
        passenger: selectedPassenger,
        bookingType: formSwitchOneWay ? "ONEWAY" : "HOURLY",
        userName: user.userName,
      };

      const hourlyPayload = {
        source: {
          placename: sourceInputFromApi?.description,
          placeid: sourceInputFromApi?.place_id,
          lat: sourceLatLan.split(",")[0],
          lng: sourceLatLan.split(",")[1],
        },
        duration: hourlyTime?.hour,
        travelDistance: hourlyTime?.distance,
        travelDate: dateChange,
        travelTime: tzUpdate,
        passenger: selectedPassenger,
        bookingType: formSwitchOneWay ? "ONEWAY" : "HOURLY",
      };

      dispatch(
        setBookingDetails({
          booking: formSwitchOneWay ? payload : hourlyPayload,
        })
      );

      if (formSwitchOneWay) {
        dispatch({
          type: "GET_MATCHING_REGIONS_AND_SEARCH_VEHICLE",
          payload: {
            b2b: true,
            navigate,
            distanceInKm: distanceInKm?.km,
            source: {
              lat: sourceLatLan.split(",")[0],
              lng: sourceLatLan.split(",")[1],
            },
            sourceLatLan,
            destinationLatLan,
            destination: {
              lat: destinationLatLan.split(",")[0],
              lng: destinationLatLan.split(",")[1],
            },
          },
        });
      } else {
        dispatch({
          type: "GET_MATCHING_REGIONS_AND_SEARCH_VEHICLE_HOURLY",
          payload: {
            navigate,
            b2b: true,
          },
        });
      }

      seteditBooking(false);
    }
  };

  // find locations when key stoke is there for source input
  const handleDestinationChange = useCallback(
    (e) => {
      dispatch(
        getVehicles({
          vehicle: undefined,
        })
      );
      dispatch(
        getVehiclesErr({
          vehicle: undefined,
        })
      );
      dispatch(
        changeDestinationInput({
          destinationInput: e.target.value,
        })
      );
      dispatch({
        type: "GET_PLACES_FROM_GOOGLE_FOR_DEST",
        payload: e.target.value,
      });
    },
    [dispatch]
  );

  const [dateValue, setDateValue] = useState(new Date());
  const [timeValue, setTimeValue] = useState("10:01");

  const onChange = (timeValue) => {
    setTimeValue(timeValue);
  };

  return (
    <>
      <div className="">
        {/* drawer */}
        {editBooking && (
          <div>
            <div
              className={`bg-black animate_animated animate_fadeUp opacity-70  cursor-pointer absolute h-full w-full mx-auto justify-center right-0 z-10 shadow-xl `}
              onClick={() => {
                seteditBooking(false);
              }}
            ></div>
            <div
              className={`bg-black px-5 transition duration-150 ease-in-out transform  absolute h-full w-[30rem] mx-auto justify-center right-0 z-10 shadow-xl `}
            >
              <div className="flex justify-between">
                <XCircleIcon
                  className="w-6 text-white cursor-pointer"
                  onClick={() => {
                    seteditBooking(false);
                  }}
                />
                <div className="text-lg text-white font-semibold text-center py-5">
                  Edit Booking
                </div>
                <div></div>
              </div>

              <div className="space-y-2">
                <InputField
                  placeholder="Address, Hotel, Airport"
                  label="From"
                  onKeyDown={(e) => {
                    if (
                      (e.key === "Backspace" || e.key === "Delete") &&
                      sourceInputFromApi
                    ) {
                      e.preventDefault();
                      dispatch(clearSourceInput());
                    }
                  }}
                  Icon={LocationMarkerIcon}
                  value={
                    sourceInputFromApi
                      ? sourceInputFromApi?.terms[0]?.value
                      : sourceInput
                  }
                  onChange={handleSourceChange}
                  onFocus={() => {
                    dispatch(
                      changeSourceInput({
                        sourceInput: "",
                      })
                    );
                  }}
                  onClickClear={() => {
                    dispatch(clearSourceInput());
                  }}
                />
                {placesbygoogle.length > 0 && (
                  <>
                    <div className="bg-white absolute w-[65%] mx-20 -translate-x-20 h-72 transform scrollbar rounded-bl-md rounded-br-md shadow-2xl z-10">
                      <div className="overflow-y-auto">
                        {placesbygoogle?.map((place) => (
                          <>
                            <AutoCompletePlaceItem
                              onClick={() => {
                                // setting source input to input field and to redux store
                                dispatch(
                                  setSourceInput({
                                    sourceInputFromApi: place,
                                  })
                                );
                                // and the same time finding lat an  lng to store to db and to get distance
                                dispatch({
                                  type: "GET_LAT_LAN_OF_SOURCE",
                                  payload: place.place_id,
                                });
                              }}
                              key={place?.place_id}
                              placeTerms={place?.terms}
                            />
                          </>
                        ))}
                      </div>
                      <div className="static flex items-center justify-end mx-3 space-x-1 text-left ">
                        <div className="text-sm font-semibold text-gray-400">
                          Powered By{" "}
                        </div>
                        <div>
                          <FontAwesomeIcon
                            icon={faGoogle}
                            className="text-red-500"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <InputField
                  placeholder="Address, Hotel, Airport"
                  label="To"
                  onKeyDown={(e) => {
                    if (
                      (e.key === "Backspace" || e.key === "Delete") &&
                      destinationInputFromApi
                    ) {
                      e.preventDefault();
                      dispatch(clearDestinationInput());
                    }
                  }}
                  Icon={LocationMarkerIcon}
                  value={
                    destinationInputFromApi
                      ? destinationInputFromApi?.terms[0]?.value
                      : destinationInput
                  }
                  onFocus={() => {
                    dispatch(
                      changeDestinationInput({
                        destinationInput: "",
                      })
                    );
                  }}
                  onChange={handleDestinationChange}
                  onClickClear={() => {
                    dispatch(clearDestinationInput());
                  }}
                />
                {placesbygoogleForDestination.length > 0 && (
                  <>
                    <div className="bg-white absolute w-[65%] mx-20 h-72 -translate-x-16 -translate-y-2  scrollbar rounded-bl-md rounded-br-md shadow-2xl z-10">
                      <div className="overflow-y-auto">
                        {placesbygoogleForDestination?.map((place) => (
                          <>
                            <AutoCompletePlaceItem
                              onClick={() => {
                                dispatch(
                                  setDestinationInput({
                                    destinationInputFromApi: place,
                                  })
                                );

                                dispatch({
                                  type: "GET_LAT_LAN_OF_DESTINATION",
                                  payload: place.place_id,
                                });
                              }}
                              key={place?.place_id}
                              placeTerms={place?.terms}
                            />
                          </>
                        ))}
                      </div>
                      <div className="static flex items-center justify-end mx-3 space-x-1 text-left">
                        <div className="text-sm font-semibold text-gray-400 ">
                          Powered By{" "}
                        </div>
                        <div>
                          <FontAwesomeIcon icon={faGoogle} />
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className="w-full bg-white rounded-sm px-2">
                  <div className="text-sm font-semibold">Date</div>
                  <DatePicker
                    format="dd-MM-y"
                    onChange={(e) => {
                      setDateValue(e);
                      setDateChange(moment(e).format("yyyy-MM-DD"));
                    }}
                    value={dateValue}
                  />
                </div>
                <div className="w-full grow relative bg-white rounded-sm h-12">
                  {Math.floor(timeDiffInSeconds / 3600) < 24 && (
                    // {true && (
                    <>
                      <div className="absolute transform translate-x-[100px] animate p-3 rounded-md text-primary font-semibold">
                        <span>
                          Time must be at least 24 hours from pick up time
                        </span>
                      </div>
                    </>
                  )}
                  <div>
                    <div className="text-sm font-semibold">Time</div>
                    <div classname="relative">
                      <TimePicker
                        onChange={handleTimeChange}
                        value={timeValue}
                        label="Time"
                        Icon={ClockIcon}
                        inputType="time"
                        className="w-full border-0"
                      />
                      <div className="absolute -translate-y-5 translate-x-1 ">
                        {timeValue}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <InputField
                    placeholder="Select passenger"
                    label="Passenger"
                    Icon={UsersIcon}
                    value={selectedPassenger}
                    onClickClear={() => {
                      dispatch(clearPassenger());
                    }}
                    onChange={() => {}}
                    onClick={() => {
                      setopenPassengerSelect(true);
                    }}
                  />
                  {openPassengerSelect && (
                    <>
                      <div className="bg-white absolute w-[65%] mx-20 h-64 transform -translate-y-5 -translate-x-20 scrollbar rounded-bl-md rounded-br-md shadow-2xl">
                        <div className="overflow-y-auto">
                          {passenger.map((passenger) => (
                            <>
                              <div
                                key={passenger}
                                onClick={() => {
                                  dispatch(
                                    selectPassenger({
                                      selectedPassenger:
                                        passenger +
                                        ` ${
                                          passenger > 1
                                            ? "Passengers"
                                            : "Passenger"
                                        } `,
                                    })
                                  );
                                  setopenPassengerSelect(false);
                                }}
                                className="flex items-center px-3 py-2 space-x-2 text-xl font-medium cursor-pointer hover:bg-primary hover:text-white"
                              >
                                <span>{passenger}</span>
                                <span>
                                  {passenger > 1 ? "Passengers" : "Passenger"}
                                </span>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {flatrate && (
                  <div>
                    <InputField
                      placeholder="USD"
                      label="Currency"
                      Icon={CashIcon}
                      value={selectdCurrency}
                      onClickClear={() => {
                        dispatch(clearCurrency());
                      }}
                      onChange={() => {}}
                      onClick={() => {
                        setOpenCurrency(true);
                      }}
                    />
                    {openCurrency && (
                      <>
                        <div className="bg-white absolute w-[12%] mx-20 h-44 transform -translate-x-20 -translate-y-5  scrollbar rounded-bl-md rounded-br-md shadow-2xl">
                          <div className="overflow-y-auto scrollbar max-h-44">
                            {Currency.map((c, index) => (
                              <>
                                <div
                                  key={index}
                                  onClick={() => {
                                    dispatch(
                                      setCurrency({
                                        selectdCurrency: c,
                                      })
                                    );
                                    setOpenCurrency(false);
                                  }}
                                  className="flex items-center px-3 py-2 space-x-2 text-xs font-medium cursor-pointer hover:bg-primary hover:text-white"
                                >
                                  <span>{c}</span>
                                </div>
                              </>
                            ))}
                          </div>
                        </div>
                        <div onClick={() => setOpenCurrency(false)}></div>
                      </>
                    )}
                  </div>
                )}
                <div
                  onClick={handleSubmit}
                  className="bg-primary hover:bg-red-700 rounded-md text-center text-white text-lg items-center flex justify-center cursor-pointer  h-10"
                >
                  Update
                </div>
              </div>
            </div>
          </div>
        )}
        {/* web view start*/}
        <div className="lg:flex w-full lg:justify-start xl:justify-between">
          {/* Booking map */}
          <div className="flex space-x-2 items-center mt-3">
            <BookingMap
              icon={faSearch}
              text="SEARCH FOR RIDE"
              active={searchCompleted}
              current={searchCurrent}
            />
            <FontAwesomeIcon icon={faArrowRight} />
            <BookingMap
              icon={faCar}
              text="CHOOSE YOUR VEHICLE"
              active={chVehicleCompleted}
              current={chVehicleCurrent}
            />
            <FontAwesomeIcon icon={faArrowRight} />
            <BookingMap
              icon={faUserTie}
              text="PASSENGER DETAILS"
              active={passengerCompleted}
              current={passengerCurrent}
            />
            <FontAwesomeIcon icon={faArrowRight} />
            <BookingMap
              icon={faList}
              text="BOOKING SUMMARY"
              active={bkSummaryCompleted}
              current={bkSummaryCurrent}
            />
          </div>

          {/* modify booking  */}
          {showBookingDetail && (
            <div
              className={`${
                b2b
                  ? "lg:mx-5 xl:w-3/4 2xl:w-1/2"
                  : "lg:mx-5 xl:mx-5 xl:w-1/2 2xl:w-2/5"
              }   hidden md:block md:w-full bg-[#aca6a640] md:mx-0 my-3 py-2 rounded-sm shadow-xl`}
            >
              <div className="flex items-center py-1 px-2 justify-between">
                <div className="text-base text-secondary font-semibold">
                  Booking Details
                </div>
                {!flatrate && (
                  <div>
                    <div>
                      <div className="flex font-serif bg-slate-100-500 px-3 rounded-sm space-x-1 items-center lg:w-full lg:h-7">
                        <CashIcon className="h-5 w-5 mr-2 lg:h-5 lg:w-10 lg:mr-3 text-secondary " />

                        <div className="w-full flex space-x-2">
                          <div className="flex justify-between">
                            <div className="text-xs font-sans font-semibold text-secondary">
                              Currency
                            </div>
                          </div>
                          <input
                            required
                            onClick={() => {
                              setOpenCurrency(true);
                            }}
                            value={selectdCurrency}
                            className="border-none focus:outline-none w-10 md:w-7 lg:w-10 text-xs lg:text-sm font-sans text-black"
                            placeholder={`USD`}
                            onChange={onChange}
                          />

                          <div>
                            <ChevronDownIcon
                              className="w-5"
                              onClick={() => {
                                setOpenCurrency(true);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {openCurrency && (
                      <>
                        <div className="bg-slate-100 absolute w-[22%] sm:w-[20%] md:w-[15%] xl:w-[11%] mx-20 h-48 transform -translate-x-5 xl:-translate-x-10 lg:-translate-x-5 sm:-translate-x-1 -translate-y-5  scrollbar rounded-bl-md rounded-br-md shadow-2xl z-10">
                          <div>
                            <FontAwesomeIcon
                              icon={faClose}
                              onClick={() => {
                                setOpenCurrency(false);
                              }}
                              className="bg-white w-5 h-5 rounded-full shadow-lg absolute -top-3 -right-2 p-1 text-red-500 text-xs"
                            />
                          </div>
                          <div className="overflow-y-auto scrollbar max-h-48">
                            {Currency.map((c, index) => (
                              <>
                                <div
                                  key={index}
                                  onClick={() => {
                                    dispatch(
                                      setConvertedPrice({
                                        convertedPrice: undefined,
                                      })
                                    );
                                    dispatch(
                                      setCurrency({
                                        selectdCurrency: c,
                                      })
                                    );
                                    dispatch(
                                      setisSearchingprice({
                                        isSearchingPrice: true,
                                      })
                                    );
                                    // vechicleCurrencyUpdate(c);
                                    setOpenCurrency(false);
                                  }}
                                  className="flex items-center px-3 py-2 space-x-2 text-[15px] font-medium cursor-pointer hover:bg-secondary hover:text-white"
                                >
                                  <span>{c}</span>
                                </div>
                              </>
                            ))}
                          </div>
                        </div>
                        <div onClick={() => setOpenCurrency(false)}></div>
                      </>
                    )}
                  </div>
                )}

                {/* pencil icon  */}
                {/* <div
                  className="text-center "
                  onClick={() => {
                    seteditBooking(true);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faPencilAlt}
                    className=" only:cursor-pointer text-gray-600 "
                  />
                </div> */}
              </div>
              <hr />
              <div className="px-2 py-2">
                <div
                  className={`${
                    b2b ? "md:grid-cols-1 gap-y-3" : "md:grid-cols-2 gap-y-3"
                  } items-center grid grid-rows-2 xl:grid-cols-2 2xl:grid-cols-2 md:gap-x-6 gap-x-20"`}
                >
                  <BookingDetailsItem
                    iconname={faMapMarker}
                    itemText={booking?.source?.placename}
                    label="From"
                  />

                  {booking?.destination?.placename && (
                    <BookingDetailsItem
                      iconname={faMapMarker}
                      itemText={booking?.destination?.placename}
                      label="To"
                    />
                  )}
                  <div className="xl:flex xl:space-x-[1px] -mt-1.5 xl:mt-0 items-start">
                    {distance && (
                      <div className="xl:w-32">
                        <BookingDetailsItem
                          iconname={faSignsPost}
                          itemText={
                            flatrate
                              ? distanceflat &&
                                Math.round(parseFloat(distanceflat)) + " km"
                              : distance
                              ? Math.round(distance) + " km"
                              : "calculating..."
                          }
                          label="Distance"
                        />
                      </div>
                    )}
                    <div className="mt-3 xl:mt-0">
                      <BookingDetailsItem
                        iconname={faClock}
                        itemText={
                          flatrate
                            ? parseFloat(durationflat).toFixed(1) + " mins"
                            : bookingDuration
                        }
                        label="Duration"
                      />
                    </div>
                  </div>
                  <div className="xl:ml-0 -mt-9 xl:mt-0">
                    <BookingDetailsItem
                      iconname={faCalendar}
                      itemText={
                        moment(booking?.travelDate).format("DD-MM-YYYY") +
                        " " +
                        booking?.travelTime?.split(" ")[1]
                      }
                      label="Date_Time"
                    />
                  </div>

                  {/* <BookingDetailsItem
                    iconname={faCalendarWeek}
                    itemText={}
                    label="Date"
                  /> */}
                </div>
              </div>
            </div>
          )}
        </div>
        {/* web view stop */}
      </div>
    </>
  );
}

export default SearchResultHeading;
